<div class="no-items-wrapper">
  <mat-icon fontSet="material-symbols-outlined">receipt_long_off</mat-icon>
  <h1>{{ 'APPLICATION.YOU_DONT_HAVE_ANY_APPLICATIONS' | translate }}</h1>
</div>
